import { gql, TypedDocumentNode } from "@apollo/client";

import {
  BlueprintParseResult,
  BlueprintVersionedGroup,
  MutationBlueprintVersionParseTemplateArgs,
  QueryBlueprintVersionedGroupArgs,
} from "types/generated";

type ValidateBlueprintVersionTemplateData = {
  blueprintVersionParseTemplate: BlueprintParseResult;
};

export const VALIDATE_BLUEPRINT_VERSION_TEMPLATE: TypedDocumentNode<
  ValidateBlueprintVersionTemplateData,
  MutationBlueprintVersionParseTemplateArgs
> = gql`
  mutation ValidateBlueprintVersionTemplate($template: String!) {
    blueprintVersionParseTemplate(template: $template) {
      errors
      inputs {
        id
        name
        default
        description
        options
        type
      }
    }
  }
`;

type GetTemplateData = {
  blueprintVersionedGroup: BlueprintVersionedGroup;
  templateSchema: string;
};

export const GET_TEMPLATE_VERSION: TypedDocumentNode<
  GetTemplateData,
  QueryBlueprintVersionedGroupArgs & { versionId: string }
> = gql`
  query GetTemplateVersion($id: ID!, $versionId: ID!) {
    blueprintVersionedGroup(id: $id) {
      id
      name
      space {
        id
        name
        accessLevel
      }
      blueprintVersion(id: $versionId) {
        id
        deleted
        name
        description
        createdAt
        updatedAt
        instructions
        state
        inputs {
          id
          name
          default
          description
          options
          type
        }
        space {
          id
          name
          accessLevel
        }
        labels
        rawTemplate
        version
        deploymentsCount
      }
      space {
        id
        name
        accessLevel
      }
    }
    templateSchema
  }
`;
